import { Component, effect, inject, signal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ScenarioService } from '@components/panel/tabs/scenario-tab/scenario.service'
import { HECTARE } from '@core/constants/scale.data'
import { CalculationModuleService } from '@core/services/calculation-module.service'
import { SelectionScaleService } from '@core/services/selection-scale.service'
import { SelectionToolService } from '@core/services/selection-tool.service'

@Component({
  selector: 'app-selection-tool',
  templateUrl: './selection-tool.component.html',
  styleUrls: ['./selection-tool.component.scss'],
  imports: [
    // Material
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class SelectionToolComponent {
  selectionToolService = inject(SelectionToolService)
  calculationModuleService = inject(CalculationModuleService)
  scenarioService = inject(ScenarioService)
  selectionScaleService = inject(SelectionScaleService)

  clearButtonText$ = signal<string>('')
  isClearBtnDisabled$ = signal<boolean>(true)
  buttonToolSelected$ = this.selectionToolService.buttonToolSelected$
  hectare = HECTARE

  private _fileToUpload: File | null = null

  constructor() {
    effect(() => {
      if (this.selectionToolService.selectedSurface$() == 0) {
        this.isClearBtnDisabled$.set(true)
      } else {
        this.isClearBtnDisabled$.set(false)
      }
    })
  }

  uploadShapes(event: Event) {
    const target = event.target as HTMLInputElement
    const files = target.files
    if (files) {
      this._fileToUpload = files.item(0)

      // Read file and insert data in geoJson variable.
      const fileReader = new FileReader()
      let geoJson: L.GeoJSON

      if (!this._fileToUpload) return
      fileReader.readAsText(this._fileToUpload, 'UTF-8')
      fileReader.onload = () => {
        geoJson = JSON.parse(fileReader.result as string)
        this.selectionToolService.drawSelectionShapeFromFile(geoJson)
      }
      fileReader.onerror = (error) => {
        console.warn('uploadShapes', error)
      }
    }
    target.value = ''
  }

  clearLayers() {
    if (this.selectionToolService.nbOfDrawnElementSelected$() >= 1) {
      this.selectionToolService.deleteSelectedAreas()
    } else {
      this.selectionToolService.clearAll()
      const fileInput = document.getElementById('fileInput') as HTMLInputElement
      if (fileInput) {
        fileInput.value = ''
      }
    }

    if (
      this.selectionToolService.nbOfElementsSelected$() == 0 &&
      this.selectionToolService.nbOfDrawnElementSelected$() == 0
    ) {
      this.isClearBtnDisabled$.set(true)
    }
  }
}
